import { render, staticRenderFns } from "./BrandListAddModal.vue?vue&type=template&id=f995385e&scoped=true&"
import script from "./BrandListAddModal.vue?vue&type=script&lang=js&"
export * from "./BrandListAddModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandListAddModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrandListAddModal.vue?vue&type=style&index=1&id=f995385e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f995385e",
  null
  
)

export default component.exports